import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { AddQuoteSlice } from 'src/app/MyQuote/AddQuote/AddQuote.slice';
import { CreateQuoteSlice } from 'src/app/MyQuote/CreateQuote/CreateQuote.slice';
import { MyQuoteDashboardSlice } from 'src/app/MyQuote/MyQuoteDashboard.slice';
import { OrderDashboardSlice } from 'src/app/Orders/OrderDashboard.slice';

import agentConversationPanelReducer from '../app/AgentConversationPanel/agentConversationPanel.slice';
import trackReducer from '../app/Track/track.slice';

import addressesReducer from './address.slice';
import authReducer from './auth.slice';
import basicReducer from './basic.slice';
import bookingStepperReducer from './bookingStepper.slice';
import { CreateOrdersSlice } from './CreateOrders.slice';
import documentHubReducer from './documentHub.slice';
import mapReducer from './map.slice';
import { authMiddleware } from './middleware/authMiddleware';
import { socketMiddleware } from './middleware/socketMiddleware';
import { mobileViewSlice } from './MobileView.slice';
import orderChatReducer from './orderChat.slice';
import { OrdersSlice } from './orders.slice';
import quoteChatReducer from './quoteChat.slice';
import { QuotingSlice } from './Quoting.slice';
import quotingFormReducer from './QuotingForm.slice';
import servicesReducer from './services.slice';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth', 'CreateQuote', 'AddQuote', 'bookingStepper'],
};

const rootReducer = combineReducers({
    MobileView: mobileViewSlice.reducer,
    auth: authReducer,
    basic: basicReducer,
    addresses: addressesReducer,
    map: mapReducer,
    quotingForm: quotingFormReducer,
    services: servicesReducer,
    quoting: QuotingSlice.reducer,
    orders: OrdersSlice.reducer,
    CreateOrders: CreateOrdersSlice.reducer,
    AddQuote: AddQuoteSlice.reducer,
    CreateQuote: CreateQuoteSlice.reducer,
    MyQuoteDashboard: MyQuoteDashboardSlice.reducer,
    OrderDashboard: OrderDashboardSlice.reducer,
    bookingStepper: bookingStepperReducer,
    orderChat: orderChatReducer,
    quoteChat: quoteChatReducer,
    documentHub: documentHubReducer,
    track: trackReducer,
    agentConversationPanel: agentConversationPanelReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(authMiddleware, socketMiddleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
